import { Boxes } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "inventory",
  icon: Boxes,
  tabs: [
    { to: "/inventory", label: "nav.stock", perm: ["inventory.stock.read"] },
    { to: "/inventory/transfers", label: "nav.transfers", perm: ["inventory.stock.transfer"], when: "manyWarehouses" },
    { to: "/inventory/counts", label: "nav.counts", perm: ["inventory.count.create"] },
    { to: "/inventory/manufacturing", label: "nav.manufacturing", perm: ["inventory.production.read"] },
    { to: "/inventory/purchase-orders", label: "nav.purchaseOrders", perm: ["inventory.po.read"] },
    { to: "/inventory/rfqs", label: "nav.rfqs", perm: ["inventory.po.read"] },
    { to: "/inventory/bills", label: "nav.bills", perm: ["inventory.bill.read"] },
    { to: "/inventory/cheques", label: "nav.supplierCheques", perm: ["inventory.bill.read"] },
    { to: "/inventory/sales-orders", label: "nav.salesOrders", perm: ["inventory.sales_order.read"] },
    { to: "/inventory/deliveries", label: "nav.deliveries", perm: ["inventory.delivery.read"] },
    { to: "/inventory/reports", label: "nav.stockReports", perm: ["inventory.report.read"] },
  ],
  create: [
    { label: "create.po", to: "/inventory/purchase-orders/new", perm: "inventory.po.create" },
    { label: "create.rfq", to: "/inventory/rfqs/new", perm: "inventory.po.create" },
    { label: "create.salesOrder", to: "/inventory/sales-orders/new", perm: "inventory.sales_order.create" },
    { label: "create.delivery", to: "/inventory/deliveries?new=1", perm: "inventory.delivery.create" },
    { label: "create.productionOrder", to: "/inventory/manufacturing?new=1", perm: "inventory.production.create" },
  ],
  settings: { to: "/settings/inventory", perm: ["inventory.settings.read"] },
  setup: { first_stock: "/inventory" },
};
